var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{attrs:{"title":_vm.$t('serial') + ': ' + _vm.device.serial}},[_vm._v(_vm._s(_vm.device.description))]),_vm._v(" "),(_vm.device.master)?_c('div',[_c('small',[_c('span',{staticClass:"grey--text text--darken-1"},[_vm._v("\n          "+_vm._s(_vm.$t('decoderControlledBy'))+":\n        ")]),_vm._v(" "),_c('router-link',{attrs:{"title":_vm.$t('goToDecoderDetailPage'),"to":{
            name: 'decoder',
            params: {
              ctype: _vm.device.master.ctype,
              decoderId: _vm.device.master.id,
            },
          }}},[_vm._v(_vm._s(_vm.device.master.description))])],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Device/DeviceDescription.vue?vue&type=template&id=e168a89c&
// module id = 2320
// module chunks = 5